export const SelectCity = selectCity => {
  return dispatch => {
    dispatch({ type: 'FETCH_AVAILABLE_RIDERS', payload: [] })
    dispatch({ type: 'SELECT_USER_CITY', payload: selectCity })
  }
}
